export default __webpack_public_path__ + "static/media/page-title-aboutus-en.3e841f18.svg";